import { IconButton, TableCell, TableRow } from '@mui/material';
import styles from './ccf-contact-history-table-content.module.scss';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import {
  CcfCallOutboundIcon,
  CcfChatIcon,
  CcfEmailIcon,
  CcfInstaIcon,
  CcfPhoneInboundIcon,
} from '@nice-ccf/ui-controls';
import CcfContactHistoryRowDetails from '../ccf-contact-history-row-details/ccf-contact-history-row-details';

/* eslint-disable-next-line */
export interface CcfContactHistoryTableContentProps {
  key: any;
  row: any;
  open: boolean;
  onClick: any;
  isAppSpace: boolean;
}

/**
 * used to show contact history table content
 * @param props - CcfContactHistoryTableContentProps
 * @example ` <CcfContactHistoryTableContent />`
 */
export function CcfContactHistoryTableContent(
  props: CcfContactHistoryTableContentProps
) {
  const { key, row, open, onClick, isAppSpace } = props;

  /**
   * Used to format contact history date and time
   * @param time -string
   * @example - formatDateTimeHandler()
   */
  const formatDateTimeHandler = (time: string) => {
    const date = new Date(time);

    return date.toLocaleDateString('en-US', {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  /**
   * Function to render Icon for Skill
   * @example renderIconForSkill()
   */
  const renderIconForSkill = (skill: string) => {
    switch (skill) {
      case 'Customer Support':
        return <CcfCallOutboundIcon className={styles.skillIcon} />;
      case 'Outbound Voice':
        return <CcfCallOutboundIcon className={styles.skillIcon} />;
      case 'Inbound Voice':
        return <CcfPhoneInboundIcon className={styles.skillIcon} />;
      case 'Email':
        return <CcfEmailIcon className={styles.skillIcon} />;
      case 'Chat':
        return <CcfChatIcon className={styles.chatIcon} />;
      case 'Instagram':
        return <CcfInstaIcon className={styles.instaIcon} />;
      default:
        return '';
    }
  };

  return (
    <>
      <TableRow
        sx={{ '& > *': { borderBottom: open ? 'none' : '' } }}
        key={key}
      >
        <TableCell className={styles.tableCell}>
          {formatDateTimeHandler(row.time)}
        </TableCell>
        <TableCell className={styles.tableCell}>{row.customer}</TableCell>
        <TableCell className={styles.tableCell}>{row.status}</TableCell>

        {!isAppSpace && (
          <>
            <TableCell className={styles.tableCell}>
              {renderIconForSkill(row.skill)}
              {row.skill}
            </TableCell>
            <TableCell className={styles.tableCell}>
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => onClick(open ? '' : row.customer)}
              >
                {open ? (
                  <KeyboardArrowUp color="secondary" />
                ) : (
                  <KeyboardArrowDown color="secondary" />
                )}
              </IconButton>
            </TableCell>
          </>
        )}
      </TableRow>
      <TableRow>
        <CcfContactHistoryRowDetails open={open} row={row} />
      </TableRow>
    </>
  );
}

export default CcfContactHistoryTableContent;
